export const contacts = {
  list: {
    count_other: "{{count}} contacts",
    count_one: "{{count}} contact",
    csv: {
      scope: "Who can see it",
      organisation: "Organisation",
      phone: "Phone",
      email: "Email",
      roles: "Roles",
      displayName: "Display name",
    },
    insight: {
      signalOrgs_other: "{{count}} organisations are missing details.",
      signalOrgs_one: "{{count}} organisation is missing details.",
      signalSkills_other: "{{count}} contractors have no skills tagged.",
      signalSkills_one: "{{count}} contractor has no skills tagged.",
      signalVisible_other: "{{count}} contacts match this view.",
      signalVisible_one: "{{count}} contact matches this view.",
      summaryMissing_other: "{{count}} contacts have no email or phone number.",
      summaryMissing_one: "{{count}} contact has no email or phone number.",
      source: "the contacts you can see",
      metricSkillGaps: "No skills",
      metricMissingReach: "No email or phone",
      metricVisible: "Shown",
      signalOrgsOk: "No organisation is missing details.",
      signalSkillsOk: "Contractors shown have skills tagged.",
      summaryOk: "Everyone shown has an email or phone number.",
      actionOrgs: "Complete organisation records before you export or report.",
      actionSkills: "Tag contractor skills so the best match is suggested for each job.",
      actionReach: "Add an email or phone number to contacts you give work to.",
    },
    historySummary: "Related work, notes and directory links",
    untitledJob: "Untitled job",
    noLinkedSkills: "No skills yet",
    noRolesAssigned: "No roles yet",
    independentContact: "Independent contact",
    kindInternal: "Internal",
    noSkillMatches: "No skill matches.",
    searchSkills: "Search skills…",
    showingA11y: "Showing: {{role}}. Change filter",
    roleAll: "All",
    noContacts: "No contacts",
    purpose: "Outside people: contractors, suppliers and clients",
    showMeHow: "Show me how",
    clearFilters: "Clear filters",
    addContractor: "Add contractor",
    title: 'Contacts',
    addContact: 'Add contact',
    loading: 'Loading…',
    emptyFilteredTitle: 'No matching contacts',
    loadFailedTitle: "We couldn't load your contacts",
    loadUnavailableTitle: 'Contacts are unavailable',
    emptyTitle: 'No contacts yet',
    emptyFilteredSubtitle: "Nothing matches these filters. Tap Clear filters to see everyone.",
    emptyContractorsTitle: 'No contractors yet',
    emptyContractorsSubtitle: "Add a contractor to give them jobs or ask them for quotes.",
    visibilityGroupA11y: 'Who can see them',
    visibilityChip: {
      all: "All",
      team: "Team only",
      account: "Whole workspace",
    },
    emptySubtitle: "Add the people and companies you work with. Contractors you add can be given jobs and asked for quotes.",
    importLabel: 'Import',
  },
  shared: {
    kindLabel: 'Contact type',
    kind: {
      person: 'Person',
      organisation: 'Organisation',
    },
    visibility: {
      team: "My team only",
      account: "Everyone in my company",
    },
    role: {
      contractor: 'Contractor',
      landlord: 'Landlord',
      owner: 'Owner',
      client: 'Client',
      agent_broker: 'Agent / broker',
      tenant: 'Tenant',
      supplier: 'Supplier',
      inspector: 'Inspector',
      occupant: 'Occupant',
      driver: 'Driver',
      fleet_manager: 'Fleet manager',
      operator: 'Operator',
      engineer: 'Engineer',
      technician: 'Technician',
      other: 'Other',
    },
    roleGroup: {
      general: 'General',
      property: 'Property',
      fleet: 'Fleet',
      equipment: 'Equipment',
    },
    roleDescription: {
      contractor: 'Can receive work, quote requests, and job updates.',
      landlord: 'Represents the property owner or ownership group.',
      owner: 'Owns the asset or portfolio this contact is linked to.',
      client: 'Requests work, reviews findings, or approves repairs.',
      agent_broker: 'Acts on behalf of the owner, client, or tenant.',
      tenant: 'Occupies or uses the asset and may report issues.',
      supplier: 'Provides materials, parts, or specialist services.',
      inspector: 'Carries out inspections, reviews, or compliance checks.',
      occupant: 'Lives in, uses, or is assigned to the asset.',
      driver: 'Drives or is assigned to a vehicle in the fleet.',
      fleet_manager: 'Manages vehicles, drivers, and fleet operations.',
      operator: 'Operates or is assigned to a piece of equipment.',
      engineer: 'Maintains, services, or repairs equipment.',
      technician: 'Hands-on servicing, testing, or repairs on equipment.',
      other: 'Use when no other role fits.',
    },
    primaryToggle: {
      primary: 'Primary',
      makePrimary: 'Make primary',
    },
    phoneType: {
      mobile: 'Mobile',
      work: 'Work',
      home: 'Home',
      other: 'Other',
    },
  },
  create: {
    contractorEmailHint: "Contractors need an email: jobs and quote requests are sent there.",
    headerSubtitleContractor: "Someone outside your team you can give jobs or ask for quotes.",
    headerTitleContractor: "New contractor",
    visibilityEveryone: "Everyone in your company can see this contact.",
    headerTitle: 'New contact',
    headerSubtitle: 'Add a person or organisation to your account directory.',
    unnamedFallback: 'Unnamed contact',
    roleSummary: '{{role}} - {{description}}',
    a11y: {
      person: 'Contact is a person',
      organisation: 'Contact is an organisation',
    },
    alerts: {
      contractorEmailRequired: "Add their email so they get jobs and quote requests.",
      contractorEmailTitle: "Add their email",
      createFailedTitle: "Couldn't add the contact",
      required: "Enter a name, email or phone number.",
      noAccountTitle: 'Account unavailable',
      noAccountBody: 'Join or create an account before adding contacts.',
      createFailed: "We couldn't add this contact. Try again in a moment.",
      emailNeededTitle: 'Email needed to share',
      emailNeededBody: "Add a valid email address — it's how this contact receives the shared asset.",
      invalidPhoneTitle: 'Check the phone number',
      invalidPhoneBody: 'Enter a valid number for the selected country, or leave the phone empty.',
    },
    sections: {
      basicIdentityTitle: 'Basic identity',
      basicIdentityHelper: 'Who this contact is and how they should appear in your directory.',
      contactInfoTitle: 'Contact information',
      contactInfoHelper: 'How your team can reach them.',
      whoIsThisTitle: 'Who is this?',
      whoIsThisHelper: 'Choose whether you are adding a person or an organisation.',
      contactMethodTitle: 'How do we contact them?',
      contactMethodHelper: 'Add the best email address and phone number for follow-up.',
      rolesWideTitle: 'Roles and types',
      rolesWideHelper: 'Select every role that should apply to this contact.',
      visibilityWideTitle: 'Visibility',
      visibilityWideHelper: 'Choose who can see and use this contact.',
      rolesTitle: 'Roles',
      rolesHelper: 'Select every role that should apply to this contact.',
      visibilityTitle: 'Visibility',
      visibilityHelper: 'Choose who can see and use this contact.',
      detailsWideTitle: 'Additional details',
      skillsTitle: 'Skills',
      skillsHelper: 'Skills decide which jobs this contact can be assigned to and who is suggested for them.',
      detailsTitle: 'Additional details',
      detailsHelper: 'Optional commercial details.',
    },
    labels: {
      displayName: 'Display name',
      organisation: 'Organisation name',
      organisations: 'Organisations',
      company: 'Company',
      email: 'Email',
      phone: 'Phone',
      companyRegistrationNumber: 'Company registration number',
      vatTaxNumber: 'VAT / tax number',
      notes: 'Notes',
      skills: 'Skills',
    },
    placeholders: {
      displayName: 'e.g. Alex Inspector',
      organisation: 'e.g. Northside Property Group',
      company: 'e.g. Northside Services',
      companyShort: 'Optional company name',
      email: 'name@example.com',
      phone: 'Best contact number',
      companyRegistrationNumber: 'Registration number (optional)',
      vatTaxNumber: 'VAT or tax number (optional)',
      notes: 'Private notes',
    },
    visibility: {
      team: "My team only",
      account: "Everyone in my company",
    },
    skillsPicker: {
      title: 'Contact skills',
      hint: 'Choose skills from your account catalog. They appear on the contact and in filters.',
    },
    actions: {
      saving: 'Saving...',
      submit: 'Add contact',
      submitContractor: 'Add contractor',
      dictate: 'Dictate',
      stopDictation: 'Stop',
    },
    // Quick-create sheet (ContactQuickCreateSheet) — a lightweight, inline
    // "create a contact right here" form used from contact pickers.
    title: 'Add contact',
    addedAs: 'Added as',
    nameLabel: 'Name',
    namePlaceholder: 'Full name',
    emailLabel: 'Email',
    saveAndUse: 'Add and use contact',
    quickCreate: {
      duplicateReason: {
        name: "Same name",
        phone: "Same phone number",
        email: "Same email address",
      },
      closeA11y: 'Close add contact',
      requiredToShareSuffix: ' · required to share',
      reviewPossibleMatch: 'Review possible match',
      discardTitle: 'Discard this contact?',
      discardBody: "You've entered contact details that haven't been saved yet.",
      keepEditing: 'Keep editing',
      discard: 'Discard',
      duplicateHeading: 'Possible existing contact',
      duplicateHint: 'Reuse an existing identity when it is the same person. Creating a separate record never merges data automatically.',
      useExisting: 'Use existing',
      useExistingA11y: 'Use existing contact {{name}}',
      createSeparate: 'Create a separate contact',
      createSeparateA11y: 'Create a separate contact after duplicate review',
    },
  },
  card: {
    noDetails: 'No contact details',
    invitedNotJoined: 'Invited · has not joined yet',
    email: 'Email',
    call: 'Call',
    emailA11y: 'Email {{name}}',
    callA11y: 'Call {{name}}',
    roles: 'Roles',
    skills: 'Skills',
    none: 'None',
    unlink: 'Unlink {{name}}',
    accessChange: 'Access: {{label}}. Change',
    access: { requester: 'Can request', viewer: 'Can view', none: 'No access' },
  },
  shareEdit: {
    sendInvite: 'Send invite',
    resendInvite: 'Resend invite',
    sending: 'Sending…',
    removeAccess: 'Remove access',
  },
  detail: {
    inviterFallback: "Someone you work with",
    noRolesYet: "No role yet. Tap Edit and choose Contractor to give them jobs.",
    inviteNeedsEmail: "Add an email address to invite {{name}}.",
    resendFailed: "Couldn't resend the invite. Try again in a moment.",
    title: 'Contact',
    loadingMessage: 'Loading contact details...',
    noContactSelected: 'No contact selected',
    contactNotFound: 'Contact not found',
    loadFailedTitle: "We couldn't load this contact",
    loadUnavailableTitle: "This contact can't be shown",
    goBack: 'Go back',
    scopeTeamOnly: "My team only",
    sectionOverview: 'Overview',
    sectionRoles: 'Roles',
    sectionContactDetails: 'Contact details',
    sectionInvitations: 'Invitations & access',
    sectionVisibility: 'Visibility',
    sectionTeamAccess: 'Team access',
    sectionSkills: 'Skills',
    sectionHistory: 'History',
    labelType: 'Type',
    labelName: 'Name',
    labelOrganisation: 'Organisation',
    labelCompany: 'Company',
    labelCompanyRegistrationNumber: 'Company registration number',
    labelVatTaxNumber: 'VAT / tax number',
    labelStatus: 'Status',
    labelEmail: 'Email',
    labelPhone: 'Phone',
    labelAudience: 'Audience',
    labelOwningTeam: 'Owning team',
    statusArchived: 'Archived',
    statusActive: 'Active',
    noEmailOrPhone: 'No email or phone',
    visibleToAllTeams: "Everyone in your company can see this contact.",
    noSkillsAssigned: 'No skills assigned. Edit the contact to add tags from your skills catalog.',
    joinedApp: 'This contact has joined the app',
    pendingInvites: 'Pending invite(s) — they can use the link to sign in',
    noInvitesYet: 'No invites yet',
    inviteSent: 'Sent {{date}}',
    inviteExpires: 'Expires {{date}}',
    inviteStatus: {
      pending: 'pending',
      accepted: 'accepted',
      revoked: 'revoked',
      expired: 'expired',
    },
    resend: 'Resend',
    revoke: 'Revoke',
    revokeInviteTitle: 'Revoke invite',
    revokeInviteMessage: 'This will cancel the invitation.',
    cancel: 'Cancel',
    edit: 'Edit',
    editContactA11y: 'Edit contact',
    contactAlreadyInApp: 'Contact already in app',
    inviteContactToAppA11y: 'Invite contact to app',
    alreadyInApp: 'Already in app',
    inviteToApp: 'Invite to app',
    invite: 'Invite',
    share: 'Share',
    shareWithTeam: 'Share with team',
    shareContactWithTeamA11y: 'Share contact with team',
    shareContactWithAnotherTeamA11y: 'Share contact with another team',
    promote: "Share with every team",
    promoteToAccount: "Share with every team",
    promoteContactToAccountA11y: "Share this contact with every team",
    promoteContactVisibilityA11y: "Share this contact with every team",
    archiveContact: 'Archive contact',
    archive: 'Archive',
    backToContactsListA11y: 'Back to contacts list',
    contactsBreadcrumb: 'Contacts',
    noOtherTeamsTitle: 'No other teams',
    noOtherTeamsBody: 'There are no other teams to share this contact with.',
    sharedTitle: 'Shared',
    sharedBody: 'Contact shared with {{team}}.',
    fallbackTeam: 'team',
    errorTitle: "That didn't work",
    failedToShare: "Couldn't share the contact. Try again in a moment.",
    promoteToAccountBody: "Everyone in your company will be able to see this contact.",
    doneTitle: 'Done',
    promotedBody: "Everyone in your company can now see this contact.",
    failedToPromote: "Couldn't share the contact with every team. Try again in a moment.",
    invitationSentTitle: 'Invitation sent',
    invitationSentBody: 'An email was sent to {{email}}.',
    invitationCreatedTitle: "Invite saved, email not sent",
    invitationCreatedBody: "We saved the invite for {{email}} but couldn't email it. Tap Resend to try again.",
    failedToCreateInvite: "Couldn't create the invite. Try again in a moment.",
    archiveContactTitle: 'Archive contact',
    archiveContactBody: 'This contact will be hidden from lists. You can restore later if needed.',
    failedToArchive: "Couldn't archive the contact. Try again in a moment.",
    invitesEmailResent: 'Sent',
    invitesEmailResentBody: 'Invite email resent.',
    inviteLinkUpdatedTitle: "Email not sent",
    inviteLinkUpdatedBody: "We couldn't email the invite. Tap Resend to try again in a moment.",
    timelineLoadingTitle: 'Loading contact activity',
    timelineErrorTitle: 'Activity is incomplete',
    timelineEmptyTitle: 'No activity yet',
    timelineLoadingSubtitle: 'Retrieving linked work and history.',
    timelineErrorSubtitle: 'Some linked records could not be loaded. Retry linked work above.',
    timelineEmptySubtitle: 'Shares, requests, inspections, jobs and invitations involving {{name}} will appear here.',
    accessLevel: {
      view: 'View',
      edit: 'Edit',
      manage: 'Manage',
    },
  },
  edit: {
    pageTitle: 'Edit contact',
    noContactId: 'No contact ID',
    contactNotFound: 'Contact not found',
    back: 'Back',
    kindA11yPerson: 'Contact type: person',
    kindA11yOrganisation: 'Contact type: organisation',
    basicIdentityHelperWide: 'Person or organisation. Display name (or first and last) is required.',
    displayNameLabel: 'Display name *',
    displayNamePlaceholder: 'Name shown in lists',
    displayNameA11yWide: 'Display name, required',
    displayNameA11yNarrow: 'Display name (required)',
    firstNameLabel: 'First name',
    firstNamePlaceholder: 'First',
    lastNameLabel: 'Last name',
    lastNamePlaceholder: 'Last',
    organisationsLabel: 'Organisations',
    contactInfoHelper: 'Used for invites and follow-up.',
    emailLabel: 'Email',
    emailPlaceholder: 'email@example.com',
    emailA11yWide: 'Email address',
    phoneLabel: 'Phone',
    whoIsThisHelperNarrow: 'Person or organisation. Name is required; organisation helps with context.',
    contactMethodHelperNarrow: 'Email or phone helps you reach them later.',
    rolesTitleWide: 'Roles & types',
    rolesTitleNarrow: 'What are they to us?',
    rolesHelper: 'Choose one or more roles so this contact appears in the right flows.',
    visibilityHelperWide: "My team only: just your team sees this contact. Everyone in my company: every team can see it.",
    visibilityTitleNarrow: 'Who can use this contact?',
    visibilityHelperNarrow: "Only your team sees it unless you choose Everyone in my company. You can share it with every team later.",
    visibilityA11yTeam: "Visibility: my team only",
    visibilityA11yAccount: "Visibility: everyone in my company",
    vatA11y: 'VAT or tax number',
    notesTitleWide: 'Notes',
    notesTitleNarrow: 'Optional details',
    notesHelper: 'Notes are private to your team.',
    improving: 'Improving...',
    improveWithAi: 'Improve with AI',
    addNotesFirstTitle: 'Add notes first',
    addNotesFirstBody: 'Type or dictate a short draft, then use Improve with AI.',
    unableToImproveNotesTitle: 'Unable to improve notes',
    improveNotesFailed: 'Could not improve the notes. Please try again.',
    tidiedNotesTitle: 'Tidied notes',
    tidiedNotesRationale: 'Review the tidied notes before applying them.',
    saveChanges: 'Save changes',
    saving: 'Saving…',
    requiredTitle: 'Required',
    requiredNameBody: 'Enter a name: display name or first and last name, or organisation name.',
    workspaceChangedError: 'Your workspace changed. Reopen the contact before continuing.',
    updateFailed: "Couldn't save your changes. Try again in a moment.",
  },
  // Import contacts flow (app/contacts/import/index.tsx + review.tsx).
  import: {
    actions: {
      addManually: 'Add manually',
      phonePicker: 'Phone picker',
      uploadFile: 'Upload a file',
    },
    access: {
      whyLine: 'AssetWRX only reads your contacts so you can pick who to add.',
      deniedTitle: 'Contacts access is off',
      deniedBody: "Allow access to see your phone's contacts here. You can still add people manually or with the phone picker.",
      allow: 'Allow access',
      openSettings: 'Open Settings',
      limited: "You've shared only some contacts with AssetWRX. Use the phone picker to add anyone else.",
      unavailableTitle: "Your phone's contacts aren't available here",
      unavailableBody: 'Importing from contacts works in the iOS and Android app. Here you can add people manually or upload a file.',
    },
    list: {
      searchA11y: 'Search contacts',
      searchPlaceholder: 'Search name, company, email or phone',
      count_one: '{{count}} contact on this phone',
      count_other: '{{count}} contacts on this phone',
      loading: 'Loading your contacts…',
      emptyTitle: 'No contacts on this phone',
      emptyBody: 'Add people manually, or use the phone picker if your contacts live in another app.',
      noMatchTitle: 'No one matches “{{query}}”',
      noMatchBody: 'Check the spelling, or search by company, email or phone.',
      alreadyAdded: 'Already in AssetWRX',
      reviewA11y: 'Review {{name}} before adding',
      selectA11y: 'Select {{name}}',
      selectAll: 'Select all ({{total}})',
      clearSelection: 'Clear selection',
      import: 'Import',
      importCount_one: 'Import {{count}}',
      importCount_other: 'Import {{count}}',
    },
    confirm: {
      title_one: 'Add {{count}} contact',
      title_other: 'Add {{count}} contacts',
      subtitle: "From your phone's contacts",
      alreadyNote_one: '{{count}} of them is already in AssetWRX and will be added again.',
      alreadyNote_other: '{{count}} of them are already in AssetWRX and will be added again.',
      roleLabel: 'Role',
      roleHelper: 'Optional. Applies to everyone you add, and you can change it later.',
      visibilityLabel: 'Who can see them',
      privacy: 'Only add people you work with. They will be visible to {{audience}}.',
      audienceTeam: 'your team',
      audienceAccount: 'everyone in your company',
      cancel: 'Cancel',
      confirm_one: 'Add {{count}}',
      confirm_other: 'Add {{count}}',
      progress: 'Adding {{done}} of {{total}}…',
      closeA11y: 'Close',
    },
    notes: {
      jobTitle: 'Job title: {{value}}',
      otherEmails: 'Other emails: {{value}}',
    },
    alerts: {
      readFailedTitle: 'Could not read contacts',
      readFailedDefaultBody: 'Try again, or use the phone picker to add people one at a time.',
      pickerFailedTitle: 'Could not open contact picker',
      pickerFailedDefaultBody: 'Grant contacts access in Settings and try again.',
      invalidContactTitle: 'Invalid contact',
      invalidContactBody: 'This contact has no usable information. Please select another.',
      noAccountTitle: 'No account',
      noAccountBody: 'You must be in an account to add contacts.',
      stoppedTitle: 'Import stopped',
      stoppedWithProgress: 'Added {{count}} before an error: {{error}}',
      unknownError: 'Unknown error',
      completeBody_one: 'Added {{count}} contact.',
      completeBody_other: 'Added {{count}} contacts.',
    },
    review: {
      requiredTitle: 'Required',
      requiredBody: 'Enter a name.',
      errorTitle: 'Error',
      errorDefaultBody: 'Failed to create contact.',
      noContactSelected: 'No contact selected. Go back and choose one from your phone.',
      backToContacts: 'Back to contacts',
      nameSectionTitle: 'Name *',
      nameA11y: 'Name (required)',
      namePlaceholder: 'Display name',
      companyA11y: 'Company (optional)',
      companyPlaceholder: 'Company (optional)',
      notesA11y: 'Notes (optional)',
      notesPlaceholder: 'Private notes (optional)',
      visibilitySectionTitle: 'Who can use this contact?',
      skillsSectionTitle: 'Skills',
      skillsPickerHint: 'Optional: attach catalog skills to this imported contact.',
      nameLabel: 'Name',
      companyLabel: 'Company',
      notesLabel: 'Notes',
      rolesSectionTitle: 'Role',
      moreDetails: 'More details',
      fewerDetails: 'Fewer details',
      extraPhones_one: 'Also adds {{count}} more number: {{numbers}}',
      extraPhones_other: 'Also adds {{count}} more numbers: {{numbers}}',
      existingTitle: 'Already in AssetWRX as {{name}}',
      existingOpen: 'Open',
      save: 'Save',
      saveAndAnother: 'Save and add another',
      addedToast: 'Added {{name}}',
    },
  },
  // Shared contact picker modal (components/ContactPickerModal.tsx).
  picker: {
    createNamed: "Create “{{search}}”",
    defaultTitle: 'Select contact',
    closeA11y: 'Close contact picker',
    searchPlaceholder: 'Search name, company, email, or role...',
    searchA11y: 'Search contacts',
    scope: {
      all: "All",
      team: "Team only",
      account: "Whole workspace",
    },
    sections: {
      recommended: 'Recommended for this work',
      recent: 'Recent',
      searchResults: 'Search results',
      allContacts: 'All contacts',
    },
    searching: 'Searching…',
    empty: {
      noMatch: "No one called “{{search}}” yet.",
      noneNoCreate: "No contacts yet.",
      none: "No contacts yet. Tap {{label}}.",
      skillsScoped: 'No {{scope}} contacts match these skills. Show all contacts, or turn off a skill filter.',
      searchScoped: 'No {{scope}} contacts match your search. Show all contacts, or try another name.',
      idleScoped: "No contacts are shared with {{scope}} yet. Show all contacts, or add one.",
      skills: 'No contacts match these skills. Turn off a skill filter or search by name.',
      search: 'No contacts match.',
      idle: 'Type to search contacts.',
    },
    showAllContacts: 'Show all contacts',
    clearScopeA11y: 'Clear the {{scope}} filter and show all contacts',
    deselectA11y: 'Deselect {{name}}',
    selectA11y: 'Select {{name}}',
    selectWithRolesA11y: 'Select {{name}}, roles {{roles}}',
    recommendedReason: 'Recommended · {{reason}}',
    workspaceWide: "Everyone",
    teamOnly: "My team only",
    skillsLabel: 'Skills',
    clear: 'Clear',
    clearSkillFiltersA11y: 'Clear skill filters',
    addFilter: 'Add filter',
    hide: 'Hide',
    hideSkillListA11y: 'Hide skill filter list',
    addSkillFiltersA11y: 'Add skill filters',
    skillFilterHint: 'Optional: filter contacts by one or more skills.',
    removeSkillFilterA11y: 'Remove {{skill}} filter',
    fromThisJob: 'From this job',
    filterBySkillA11y: 'Filter by {{skill}}',
    searchSkillsPlaceholder: 'Search skills...',
    searchSkillsA11y: 'Search skills',
    noSkillsMatch: 'No skills match your search.',
    addAction: 'Add',
    removeAction: 'Remove',
    toggleSkillFilterA11y: '{{action}} {{skill}} filter',
    selectedCount_one: "{{count}} selected",
    selectedCount_other: "{{count}} selected",
    continueLabel: 'Continue',
    continueWithA11y: 'Continue with {{count}} {{noun}}',
    contactNoun_one: 'contact',
    contactNoun_other: 'contacts',
  },
  // OrganisationsField — repeating org-link editor on the create/edit screens.
  organisationsField: {
    empty: 'No organisations linked yet.',
    chooseOrganisation: 'Choose organisation',
    primaryA11y: 'Primary organisation',
    removeA11y: 'Remove organisation',
    titlePlaceholder: 'Title (e.g. Reliability Lead)',
    titleA11y: 'Title at organisation',
    addA11y: 'Add organisation',
    addLabel: 'Add organisation',
    pickerTitle: 'Select organisation',
  },
  // PhonesField — repeating phone-number editor on the create/edit screens.
  phonesField: {
    empty: 'No phone numbers yet.',
    phoneTypeA11y: 'Phone type {{label}}',
    primaryA11y: 'Primary phone',
    removeA11y: 'Remove phone',
    addA11y: 'Add phone number',
    addLabel: 'Add phone',
  },
  // Contact 360 (components/contacts/ContactThreeSixty.tsx).
  threeSixty: {
    assetSharedTitle: '{{asset}} shared with {{name}}',
    shareSubtitle: 'Share · {{status}}',
    requestSubtitle: 'Request · {{status}}',
    jobFallback: 'Job',
    inspectionLabel: 'Inspection',
    contactJoinedTitle: '{{name}} joined the app',
    invitedTitle: 'Invited to the app ({{email}})',
    invitationSubtitle: 'Invitation · {{status}}',
    appStandingInApp: 'In the app',
    appStandingPending: 'Invite pending since {{when}}',
    appStandingNotInvited: 'Not invited yet',
    statusActive: 'Active',
    lastActivity: 'Last activity {{when}}',
    noActivityYet: 'No activity yet',
    noEmailOrPhone: 'No email or phone on file.',
    emailA11y: 'Email {{email}}',
    callA11y: 'Call {{phone}}',
    openWork: {
      sharedAssets: 'Shared assets',
      openRequests: 'Open requests',
      openInspections: 'Open inspections',
      openJobs: 'Open jobs',
    },
    openWorkInfo: {
      sharedAssetsDesc: 'Assets this contact can see and raise requests on through an active share.',
      sharedAssetsBasedOn: '{{active}} of {{total}} shares still active, counted live',
      openRequestsDesc: 'Requests from or for this contact that have not been closed, declined or converted.',
      openRequestsBasedOn: '{{open}} of {{total}} requests still open, counted live',
      openInspectionsDesc: 'Inspections linked to this contact that have not been completed.',
      openInspectionsBasedOn: '{{open}} of {{total}} linked inspections, counted live',
      openJobsDesc: 'Unfinished jobs explicitly linked to this contact. Work assigned only through their user account may not appear here.',
      openJobsBasedOn: '{{open}} of {{total}} linked jobs, counted live',
    },
    loadingLinkedWork: 'Loading linked work',
    linkedWorkErrorTitle: 'Linked work could not be loaded',
    openWithName: 'Open with {{name}}',
    noOpenWork: "{{name}} has no open work. To give them a job, open the job and tap Assign.",
  },
  // Contact detail operational sections (components/contacts/ContactOperationalSections.tsx
  // and contactOperationalUtils.ts).
  operational: {
    tabsLabel: 'Contact sections',
    tabs: {
      overview: 'Overview',
      assets: 'Assets',
      requests: 'Requests',
      history: 'History',
    },
    sharedAssetsTitle: 'Shared Assets',
    sharedAssetsEmpty: 'No assets shared yet. Share an asset to let this contact request inspections or propose jobs.',
    requestsTitle: 'Requests',
    requestsEmpty: 'No requests from this contact yet.',
    relatedWorkTitle: 'Related Work',
    relatedWorkEmpty: 'No related jobs or inspections yet.',
    notesTitle: 'Notes',
    notesEmpty: 'No notes on this contact.',
    assetLinksTitle: 'Asset links',
    assetLinksHelper: 'Record-level links (not the same as workspace sharing).',
    assetFallback: 'Asset',
    jobFallback: 'Job',
    workspaceAccess: 'Workspace access',
    permissionJobs: 'Jobs',
    permissionInspections: 'Inspections',
    permissionDocuments: 'Documents',
    scheduleProposedAndScheduled: 'Proposed {{proposed}} · Scheduled {{scheduled}}',
    scheduleScheduled: 'Scheduled {{scheduled}}',
    scheduleProposed: 'Proposed {{proposed}}',
    statusPrefix: 'Status {{status}}',
    openRequestCount_one: '{{count}} open request',
    openRequestCount_other: '{{count}} open requests',
    openAssetA11y: 'Open asset {{name}}',
    requestA11y: 'Request {{title}}',
    jobA11y: 'Job {{label}}',
    inspectionA11y: 'Inspection {{title}}',
    shareAsset: 'Share asset',
    shareAssetA11y: 'Choose an asset to share',
    allRequests: 'All requests',
    allRequestsA11y: 'View all requests',
    email: 'Email',
    emailA11y: 'Email contact',
    invite: 'Invite',
    inApp: 'In app',
    inviteA11y: 'Invite contact',
    shareContact: 'Share contact',
    shareContactA11y: 'Share contact with team',
  },
  // ContactLinkCard.tsx + ContactAccessChip.tsx (asset/site "linked contacts" card).
  linkCard: {
    unlinkA11y: 'Unlink contact',
    otherRole: 'Other',
    contactFallback: 'Contact',
  },
  inviteLanding: {
    acceptFailed: "Couldn't accept the invitation. Try again, or ask whoever sent it for a new one.",
    acceptFailedTitle: "Couldn't accept the invitation",
    accepted: "You're in. Anything shared with you is on Home.",
    expired: "This invitation has expired. Ask whoever sent it for a new one.",
    desc: "{{name}}, you've been invited to AssetWRX. Sign in to see what's been shared with you.",
  },
} as const;
